import URL_ROUTE from '../constants/index';

const token = sessionStorage.getItem('token');

class Api {
    async login(email, password) {
        let data = {
            email,
            password,
            //ip
        };
        const query = await fetch(`${URL_ROUTE.LOGIN}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }

    async selectDB() {
        const query = await fetch(`${URL_ROUTE.SELECTDB}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return query
    }

    // List databases (GET)
    async listDBs() {
        const query = await fetch(`${URL_ROUTE.GET_DBS}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return query
    }

    // Create a new database record. Payload: { host, port, database, username, password, project }
    async createDB(payload) {
        const query = await fetch(`${URL_ROUTE.CREATE_DBS}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        return query
    }

    // Update an existing database record. Payload: { project, host, port, database, username, password }
    async updateDB(payload) {
        const query = await fetch(`${URL_ROUTE.UPDATE_DBS}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        return query
    }

    // Delete a database by uuid. Payload: { uuid }
    async deleteDB(uuid) {
        const query = await fetch(`${URL_ROUTE.DELETE_DBS}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ uuid })
        });
        return query
    }

    async listStateForNumber() {
        const query = await fetch(`${URL_ROUTE.LISTSTATEFORNUMBER}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return query
    }

    //Usa XHR para poder medir la subida; el avance del procesamiento llega por WebSocket (jobId)
    verifyNumbersExcel(upload, jobId, onUploadProgress) {
        let formData = new FormData();
        //El jobId va antes del archivo para que el backend lo reciba en req.body
        if (jobId) formData.append('jobId', jobId);
        formData.append('upload', upload);

        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', `${URL_ROUTE.VERIRYNUMBEREXCEL}`);
            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            xhr.responseType = 'blob';
            if (onUploadProgress) {
                xhr.upload.onprogress = (e) => {
                    if (e.lengthComputable) onUploadProgress(Math.round((e.loaded / e.total) * 100));
                };
            }
            xhr.onload = () => resolve(xhr.response);
            xhr.onerror = () => reject(new Error('Error de red verificando números'));
            xhr.send(formData);
        });
    }

    async validateNumberStateExcel(upload) {
        let formData = new FormData();
        formData.append('upload', upload);

        const query = await fetch(`${URL_ROUTE.VALIDATENUMBERSTATEEXCEL}`, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token
            },
            responseType: 'blob',
            body: formData
        });
        return query;
    }

    async extrapolateNumbersFromExcel(formData) {
        const query = await fetch(`${URL_ROUTE.EXTRAPOLATE_NUMBERS_FROM_EXCEL}`, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token
            },
            body: formData
        });
        return query;
    }

    async verifyNumbersAsesorExcel(upload) {
        let formData = new FormData();
        formData.append('upload', upload);

        const query = await fetch(`${URL_ROUTE.VERIRYNUMBERASESOREXCEL}`, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token
            },
            responseType: 'blob',
            body: formData
        });
        return query;
    }

    async loadNumbersCreateExcel(upload, indicative, totalNumber, position, direction, includeNumber, project, interval, country, invalidNumber) {
        let formData = new FormData();
        formData.append('upload', upload);
        formData.append('indicative', indicative);
        formData.append('totalNumber', totalNumber);
        formData.append('position', position);
        formData.append('direction', direction);
        formData.append('includeNumber', includeNumber);
        formData.append('project', project);
        formData.append('interval', interval);
        formData.append('country', country);
        formData.append('invalidNumber', invalidNumber);

        console.log(position, "position");
        console.log(direction, "direction");
        console.log(project, "project");
        console.log(country, "country");
        console.log(invalidNumber, "invalidNumber");

        const query = await fetch(`${URL_ROUTE.LOADNUMBERSCREATEEXCEL}`, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token
            },
            responseType: 'blob',
            body: formData
        });
        return query;
    }

    async loadNumbersStateCreateExcel(upload, indicative, totalNumber, position, direction, includeNumber, project, interval, state) {
        let formData = new FormData();
        formData.append('upload', upload);
        formData.append('indicative', indicative);
        formData.append('totalNumber', totalNumber);
        formData.append('position', position);
        formData.append('direction', direction);
        formData.append('includeNumber', includeNumber);
        formData.append('project', project);
        formData.append('interval', interval);
        formData.append('state', state);

        const query = await fetch(`${URL_ROUTE.LOADNUMBERSSTATECREATEEXCEL}`, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token
            },
            responseType: 'blob',
            body: formData
        });
        return query;
    }

    async loadNumbersTrashExcel(upload) {
        let formData = new FormData();
        formData.append('upload', upload);

        const query = await fetch(`${URL_ROUTE.LOADNUMBERSTRASHEXCEL}`, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token,
            },
            body: formData
        });
        return query;
    }

    async loadNumbersTipifyCalls(upload, tipify, project) {
        let formData = new FormData();
        formData.append('upload', upload);
        formData.append('tipify', tipify);
        formData.append('project', project);

        const query = await fetch(`${URL_ROUTE.LOADNUMBERSTIPIFYCALLS}`, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token,
            },
            body: formData
        });
        return query;
    }

    async listNumbersTipifyCalls(tipify, nameTipify) {
        const data = {tipify: tipify != '' ? tipify : '-', nameTipify: nameTipify != '' ? nameTipify : '-'}
        const query = await fetch(`${URL_ROUTE.LISTNUMBERTIPIFYCALLS}`, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query;
    }

    async filterNumbersTipifyCalls(tipify, nameTipify, dateStart, dateEnd) {
        const data = {tipify: tipify != '' ? tipify : '-', nameTipify: nameTipify != '' ? nameTipify : '-', dateStart, dateEnd}
        const query = await fetch(`${URL_ROUTE.FILTERNUMBERTIPIFYCALLS}`, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query;
    }

    async loadNumbers(project, state, totalNumber, totalPhone, position, indicative) {
        let data = { project, state, totalNumber, totalPhone, position, indicative}
        const query = await fetch(`${URL_ROUTE.LOADNUMBERS}`, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            responseType: 'blob',
            body: JSON.stringify(data)
        });
        return query;
    }

    async loadNumbersvii(totalNumber, totalPhone, position, indicative, date_start, date_end) {
        let data = { totalNumber, totalPhone, position, indicative, date_start, date_end }
        const query = await fetch(`${URL_ROUTE.LOADNUMBERSVII}`, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            /* responseType: 'blob', */
            body: JSON.stringify(data)
        });
        return query;
    }

    async downloadExcelNumber(phones) {
        let data = { phones}
        const query = await fetch(`${URL_ROUTE.DOWNLOADEXCELNUMBER}`, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            responseType: 'blob',
            body: JSON.stringify(data)
        });
        return query;
    }

    async downloadExcelNumberTipifyCalls(details) {
        let data = { details}
        console.log(data, "data");
        const query = await fetch(`${URL_ROUTE.DOWNLOADEXCELNUMBERTIPIFYCALLS}`, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            responseType: 'blob',
            body: JSON.stringify(data)
        });
        return query;
    }

    async viewListLog() {
        //let data = { project}
        const query = await fetch(`${URL_ROUTE.VIEWLISTLOG}`, {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            //body: JSON.stringify(data)
        });
        return query;
    }

    async listTrashNumber() {
        const query = await fetch(`${URL_ROUTE.LISTTRASHNUMBER}`, {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
        });
        return query;
    }

    async createuser(email, name, lastname, password, idprofile) {
        let data = { email, name, lastname, password, idprofile }
        const query = await fetch(`${URL_ROUTE.CREATEUSERS}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }

    async listusers() {
        const query = await fetch(`${URL_ROUTE.LISTUSERS}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return query
    }

    async listLogsBackups() {
        const query = await fetch(`${URL_ROUTE.LISTLOGSBACKUPS}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return query
    }

    async listDBBackups() {
        const query = await fetch(`${URL_ROUTE.LISTDBBACKUPS}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return query
    }

    async deleteDBBackup(uuid) {
        const data = { uuid }
        const query = await fetch(`${URL_ROUTE.DELETEDBBACKUP}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }

    async createBdBackups(host, port, database, username, password, project, type, uuid) {
        let data = { host, port, database, username, password, project, type, uuid }
        const query = await fetch(`${URL_ROUTE.CREATEBDBACKUPS}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }

    async backupDatabase() {
        const query = await fetch(`${URL_ROUTE.BACKUPDATABASE}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return query
    }

    async totalSales(policytype, uuid) {
        let data = { policytype, uuid }
        const query = await fetch(`${URL_ROUTE.TOTALSALES}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }

    async totalSalesRenew(uuid) {
        let data = { uuid }
        const query = await fetch(`${URL_ROUTE.TOTALSALESRENEW}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }

    async totalSalesAgents(date, policytype, uuid) {
        let data = { date, policytype, uuid }
        const query = await fetch(`${URL_ROUTE.TOTALSALESAGENTS}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }

    async indicadoresBase(payload) {
        const query = await fetch(`${URL_ROUTE.INDICADORESBASE}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        return query
    }

    async createProvider(name) {
        const query = await fetch(`${URL_ROUTE.CREATEPROVIDER}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ name })
        });
        return query
    }

    async listProvider(uuid, name) {
        const query = await fetch(`${URL_ROUTE.LISTPROVIDER}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        return query
    }

    async listCreateNumbers({ page = 1, limit = 20 } = {}) {
        const query = await fetch(`${URL_ROUTE.LISTCREATENUMBERS}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ page, limit }),
        });
        return query
    }

    async getProviderNumbersDetail({ uuid_provider, uuid }) {
        const query = await fetch(`${URL_ROUTE.GET_PROVIDER_NUMBERS_DETAIL}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ uuid_provider, uuid }),
        });
        return query
    }

    async getNumberRequests() {
        // Calls the endpoint to retrieve count/summary of number requests for notifications
        const query = await fetch(`${URL_ROUTE.GET_NUMBER_REQUESTS}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        });
        return query;
    }

    async updateProvider(uuid, name) {
        const query = await fetch(`${URL_ROUTE.UPDATEPROVIDER}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ name, uuid })
        });
        return query
    }

    async updateStatusProvider(uuid, status) {
        const query = await fetch(`${URL_ROUTE.UPDATESTATUSPROVIDER}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ uuid, status })
        });
        return query
    }

    async createNumber(upload, uuid_provider,  name_database ) {
        let formData = new FormData();
        formData.append('upload', upload);
        formData.append('uuid_provider', uuid_provider);
        formData.append('name_database', name_database);

        const query = await fetch(`${URL_ROUTE.CREATENUMBER}`, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token,
            },
            responseType: 'blob',
            body: formData
        });
        return query;
    }

    // Process number file: used by the new upload modal to process file and return JSON summary
    // Uses the same endpoint as createNumber but returns JSON (server should detect form data and return JSON preview)
    async processNumberFile(formData) {
        const query = await fetch(`${URL_ROUTE.CREATENUMBER}`, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token,
                Accept: 'application/json'
            },
            body: formData
        });
        return query;
    }

    // Finalize number upload: confirm processing stored in Redis or persisted backend.
    // Uses the same createNumber endpoint semantics but sends a small FormData with file_uuid and confirm flag.
    async finalizeNumberUpload({ file_uuid, confirm_processing }) {
        const formData = new FormData();
        formData.append('file_uuid', file_uuid);
        formData.append('confirm_processing', confirm_processing ? '1' : '0');

        const query = await fetch(`${URL_ROUTE.CREATENUMBER}`, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token,
                Accept: 'application/json'
            },
            body: formData
        });
        return query;
    }

    async exportNumbers(uuid) {
        const query = await fetch(`${URL_ROUTE.EXPORTNUMBERS}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ uuid }),
            responseType: 'blob',
        });
        return query;
    }

    // Delete an uploaded file for a provider. Payload: { file_uuid, uuid_provider }
    async deleteProviderFile({ file_uuid, uuid_provider }) {
        const data = { file_uuid, uuid_provider };
        const query = await fetch(`${URL_ROUTE.DELETE_PROVIDER_FILE}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query;
    }

    async extrapolateNumbers(payload) {
        const query = await fetch(`${URL_ROUTE.EXTRAPOLATENUMBERS}`, {
            method: 'POST',
            headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload),
        });

        if (!query.ok) {
            let errorMessage = 'Error generando el Excel';

            const errorText = await query.text();
            if (errorText) {
                errorMessage = errorText;
            }


            throw new Error(errorMessage);
        }

        const blob = await query.blob();

        const disposition = query.headers.get('Content-Disposition');
        let filename = 'extrapolated_numbers.xlsx';

        if (disposition) {
            const match = disposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) {
            filename = match[1];
            }
        }

        return { blob, filename };
    }

    async extrapolateNumbersJson(payload) {
        try {
            const query = await fetch(`${URL_ROUTE.EXTRAPOLATENUMBERSJSON}`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload),
            });

            // Inspect content type to decide how to read the body
            const contentType = (query.headers.get('Content-Type') || query.headers.get('content-type') || '').toLowerCase();

            // If backend returned a binary file (Excel) or non-json, return blob + filename
            const isBinary = !contentType.includes('application/json') && (contentType.includes('application/vnd.openxmlformats') || contentType.includes('application/octet-stream') || contentType.includes('application/pdf') || contentType === '');

            if (isBinary) {
                // read as blob and return filename when available
                const blob = await query.blob();
                const disposition = query.headers.get('Content-Disposition') || query.headers.get('content-disposition') || '';
                let filename = 'extrapolated_numbers.xlsx';
                if (disposition) {
                    const match = disposition.match(/filename\*?=([^;]+)/);
                    if (match) {
                        // trim possible encoding prefix
                        filename = match[1].replace(/UTF-8''/, '').replace(/"/g, '').trim();
                    }
                }

                if (!query.ok) {
                    return { success: false, data: null, message: 'Error generando extrapolación (archivo)', blob, filename };
                }

                return { success: true, data: null, blob, filename };
            }

            const text = await query.text();

            if (!query.ok) {
                return { success: false, data: null, message: text || 'Error generando extrapolación' };
            }

            let parsed = null;
            try {
                parsed = text ? JSON.parse(text) : null;
            } catch (e) {
                // If parsing fails return raw text as message
                return { success: false, data: null, message: 'Respuesta inválida del servidor: ' + text };
            }

            // Normalize response shape
            if (parsed && typeof parsed === 'object') {
                const success = parsed.success !== undefined ? parsed.success : true;
                const data = parsed.data !== undefined ? parsed.data : parsed;
                const message = parsed.message || parsed.msg || '';
                return { success, data, message };
            }

            return { success: true, data: parsed };
        } catch (error) {
            return { success: false, data: null, message: error.message || 'Error generando extrapolación' };
        }
    }

    async listExtrapolatedNumbers(payload) {
        try {
            // If payload is provided, send as query string since backend expects GET
            const queryString = payload && typeof payload === 'object'
                ? `?${new URLSearchParams(payload).toString()}`
                : '';

            const url = `${URL_ROUTE.LIST_EXTRAPOLATED_NUMBERS}${queryString}`;

            const query = await fetch(url, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            });

            const text = await query.text();

            if (!query.ok) {
                const errorMessage = text || 'Error obteniendo las extrapolaciones';
                return { success: false, data: [], message: errorMessage };
            }

            // Try to parse JSON response. Backend may return either an array or an object.
            let parsed = null;
            try {
                parsed = text ? JSON.parse(text) : null;
            } catch (e) {
                // If parsing fails, return empty data with a parsing message
                return { success: false, data: [], message: 'Respuesta inválida del servidor' };
            }

            if (Array.isArray(parsed)) {
                return { success: true, data: parsed };
            }

            if (parsed && typeof parsed === 'object') {
                // Normalize common shapes: { success, data, message } or { data: [...] }
                const success = parsed.success !== undefined ? parsed.success : true;
                const data = parsed.data !== undefined ? parsed.data : (parsed.items || []);
                const message = parsed.message || parsed.msg || '';
                return { success, data, message };
            }

            // If parsed is null/unknown, return empty success
            return { success: true, data: [] };
        } catch (error) {
            return { success: false, data: [], message: error.message || 'Error obteniendo las extrapolaciones' };
        }
    }

    async totalAgents(uuid) {
        let data = { uuid }

        const query = await fetch(`${URL_ROUTE.TOTALAGENTS}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }

    async reAssignmentNumbers(payload) {
        const endpoint = URL_ROUTE.RE_ASSIGNMENT_NUMBERS;
        const query = await fetch(endpoint, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        return query;
    }

    async reAssignNumbersAgentToAgents(payload) {
        const query = await fetch(URL_ROUTE.RE_ASSIGNMENT_NUMBERS_AGENT_TO_AGENTS, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        return query;
    }

    async reAssignNumbersAgentToAgents(payload) {
        const query = await fetch(`${URL_ROUTE.RE_ASSIGNMENT_NUMBERS_AGENT_TO_AGENTS}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        return query;
    }

    async saveAssignedNumbers(payload) {
        const endpoint = URL_ROUTE.SAVE_ASSIGNED_NUMBERS;

        const query = await fetch(endpoint, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        return query;
    }

    async validateUploadPhones(database, phones) {
        const payload = {
            uuid: database,
            phones: Array.isArray(phones) ? phones : [phones]
        };

        const query = await fetch(`${URL_ROUTE.VALIDATE_UPLOAD_PHONES}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        return query;
    }

    async generateMissingNumbers(payload) {
        try {
            const query = await fetch(`${URL_ROUTE.GENERATE_MISSING_NUMBERS_JSON}`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            const text = await query.text();

            if (!query.ok) {
                const errorMessage = text || 'Error generando números faltantes';
                return { success: false, data: null, message: errorMessage };
            }

            let parsed = null;
            try {
                parsed = text ? JSON.parse(text) : null;
            } catch (e) {
                return { success: false, data: null, message: 'Respuesta inválida del servidor: ' + text };
            }

            if (parsed && typeof parsed === 'object') {
                const success = parsed.success !== undefined ? parsed.success : true;
                const data = parsed.data !== undefined ? parsed.data : parsed;
                const message = parsed.message || parsed.msg || '';
                return { success, data, message };
            }

            return { success: true, data: parsed };
        } catch (error) {
            return { success: false, data: null, message: error.message || 'Error generando números faltantes' };
        }
    }

    async validatedNumber(payload) {
        const endpoint = URL_ROUTE.VALIDATED_NUMBER_REQUESTS; 
        const query = await fetch("https://apidba.ticinnovation.org:17709/api/v1/app/request/db", {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        // const query = await fetch(endpoint, {
        //     method: 'POST',
        //     headers: {
        //         Authorization: `Bearer ${token}`,
        //         'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify(payload)
        // });
        return query;
    }

    async validatedSalesIds(payload) {
        const endpoint = URL_ROUTE.VALIDATED_SALES_IDS;
        const query = await fetch(endpoint, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        return query;
    }

    async updateValidateSalesIds(payload) {
        const endpoint = URL_ROUTE.UPDATES_VALIDATED_SALES_IDS;
        const query = await fetch(endpoint, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        return query;
    }

    async getProjectByDB(id) {
        // backend expects { id: '<db-uuid>' } in the POST body
        const endpoint = URL_ROUTE.GET_PROJECT_BY_DB;
        const query = await fetch(endpoint, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id })
        });
        return query;
    }

    async getDaylySumary(payload) {
        const endpoint = URL_ROUTE.GET_DAYLY_SUMARY;
        const query = await fetch(endpoint, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        return query;
    }


    async getProjectSalesmen(uuid) {
        const query = await fetch(`${URL_ROUTE.GET_PROJECT_SALESMEN}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ uuid })
        });
        return query
    }

    async getProjectNpns(uuid) {
        const query = await fetch(`${URL_ROUTE.GET_PROJECT_NPNS}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ uuid })
        });
        return query
    }

    async transferProjectToProject(payload) {
        const query = await fetch(`${URL_ROUTE.TRANSFER_PROJECT_TO_PROJECT}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        return query
    }
}

export default new Api();